module.exports = __webpack_public_path__ + "content/21b448be009a604dfb6032f3c2075131.png";